import { render, staticRenderFns } from "./ElProcSyDetails.vue?vue&type=template&id=11b4140e&scoped=true&"
import script from "./ElProcSyDetails.vue?vue&type=script&lang=js&"
export * from "./ElProcSyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4140e",
  null
  
)

export default component.exports